import { render, staticRenderFns } from "./RespSafeRegContact.vue?vue&type=template&id=28926487&scoped=true"
import script from "./RespSafeRegContact.vue?vue&type=script&lang=js"
export * from "./RespSafeRegContact.vue?vue&type=script&lang=js"
import style0 from "./RespSafeRegContact.vue?vue&type=style&index=0&id=28926487&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28926487",
  null
  
)

export default component.exports